export const FECHAR_AO_CLICAR_FORA = false; /*<- altere aqui para permitir/não permitir fechamento ao clicar fora*/

const podeFecharAoClicarFora = (permitirFechar = true) => {
  return Boolean(FECHAR_AO_CLICAR_FORA) && Boolean(permitirFechar);
};

export default podeFecharAoClicarFora;
